import React, { useState, useEffect } from 'react';
import cloudIcon from '../../../assets/icons/cloud-icon-colored.png';
import { AgCharts } from 'ag-charts-react';
import rainDropsIcon from '../../../assets/icons/raindrops.png';
import windIcon from '../../../assets/icons/wind.png';
import directionArrow from '../../../assets/icons/direction-arrow.png';
import humidityIcon from '../../../assets/icons/humdity.png';
import snowIcon from '../../../assets/icons/snow-blue.png';
import tempRedIcon from '../../../assets/icons/temp-red.png';
import tempBlueIcon from '../../../assets/icons/temp-blue.png';
import Spinner from '../../Spinner';
import axios from 'axios';
import left from '../../../assets/icons/left.png';

export default function Forecast(props) {
    const {
        coordinates,
        setMainStage
    } = props;

    const [stage, setStage] = useState('7-Day Forecast');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [weatherData, setWeatherData] = useState(null);
    const [graphData, setGraphData] = useState(null);

    const formatDate = (timestamp) => {
        const daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        const date = new Date(timestamp * 1000);
        const today = new Date();
        
        if (date.toDateString() === today.toDateString()) {
          return 'Today';
        } else {
          const dayOfWeek = daysOfWeek[date.getDay()];
          return dayOfWeek;
        }
    }

    const getWindDirection = (degrees) => {
        const blowingToDeg = (degrees + 180) % 360;
    
        if (blowingToDeg >= 337.5 || blowingToDeg < 22.5) return 'North';
        if (blowingToDeg >= 22.5 && blowingToDeg < 67.5) return 'North-East';
        if (blowingToDeg >= 67.5 && blowingToDeg < 112.5) return 'East';
        if (blowingToDeg >= 112.5 && blowingToDeg < 157.5) return 'South-East';
        if (blowingToDeg >= 157.5 && blowingToDeg < 202.5) return 'South';
        if (blowingToDeg >= 202.5 && blowingToDeg < 247.5) return 'South-West';
        if (blowingToDeg >= 247.5 && blowingToDeg < 292.5) return 'West';
        if (blowingToDeg >= 292.5 && blowingToDeg < 337.5) return 'North-West';
    
        return 'Unknown';
    }

    const calculateArrowRotation = (windFromDeg) => {
        const blowingToDeg = (windFromDeg + 180) % 360; 
        return blowingToDeg; 
    }; 

    const getForecast = (coordinates) => {
        setError(false);
        setLoading(true);
        axios.get(`https://firewatch-api.space-eyes.com/weather/forecast?lat=${coordinates[1]}&long=${coordinates[0]}`)
        .then((response) => {
            setLoading(false);
            console.log(response.data.list.slice(0, 7))
            setWeatherData(response.data.list.slice(0, 7));
            setGraphData([
                {
                
                    title: 'Rain Volume (mm)',
                    series: [
                        {
                            type: "line",
                            xKey: "day",
                            xName: "Date",
                            yKey: 'rain',
                            yName: 'Rain Volume',
                            interpolation: { type: "smooth" },
                        },
                    ],
                    data: response.data.list.slice(0, 7).map((d) => {
                        return {
                            day: convertTimestampToReadableString(d.dt), 
                            rain: d.rain ? d.rain : 0
                        }
                    })
                },
                {
                
                    title: 'Min and Max Temperatures (°F)',
                    yKey: '',
                    yName: 'Rain Volume',
                    series: [
                        {
                            type: "line",
                            xKey: "day",
                            xName: "Date",
                            yKey: "min",
                            yName: "Min Temperature",
                            interpolation: { type: "smooth" },
                        },
                        {
                            type: "line",
                            xKey: "day",
                            xName: "Date",
                            yKey: "max",
                            yName: "Max Temperature",
                            interpolation: { type: "smooth" },
                        },
                    ],
                    data: response.data.list.slice(0, 7).map((d) => {
                        return {
                            day: convertTimestampToReadableString(d.dt), 
                            max: ((d.temp.max - 273.15) * (9/5) + 32) ? ((d.temp.max - 273.15) * (9/5) + 32) : 0, 
                            min: ((d.temp.min - 273.15) * (9/5) + 32) ? ((d.temp.min - 273.15) * (9/5) + 32) : 0, 
                        }
                    })
                },
                {
                    title: 'Wind Speed (mph)',
                    series: [
                        {
                            type: "line",
                            xKey: "day",
                            xName: "Date",
                            yKey: 'speed',
                            yName: 'Wind Speed',
                            interpolation: { type: "smooth" },
                        },
                    ],
                    data: response.data.list.slice(0, 7).map((d) => {
                        return {
                            day: convertTimestampToReadableString(d.dt), 
                            speed: (d.speed * 2.23694) ? (d.speed * 2.23694) : 0, 
                        }
                    })
                },
                {
                    title: 'Humidity (%)',
                    series: [
                        {
                            type: "line",
                            xKey: "day",
                            xName: "Date",
                            yKey: 'humidity',
                            yName: 'Humidity',
                            interpolation: { type: "smooth" },
                        },
                    ],
                    data: response.data.list.slice(0, 7).map((d) => {
                        return {
                            day: convertTimestampToReadableString(d.dt), 
                            humidity: (d.humidity) ? d.humidity : 0, 
                        }
                    })
                }
            ])
        }).catch((err) => {
            console.log('error calling weather api', err);
            setLoading(false);
            setError('Trouble fetching weather forecast. Please try again.');
        })
    }

    useEffect(() => {
        getForecast(coordinates)
    }, [coordinates]);

    const convertTimestampToReadableString = (timestamp) => {
        const date = new Date(timestamp * 1000);
      
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        const year = date.getFullYear().toString().slice(-2);
      
        const formattedDate = `${month}/${day}/${year}`;
      
        return formattedDate;
    }

    const stageSwitch = (stage) => {
        switch (stage) {
            case '7-Day Forecast':
                return (      
                    <div className='forecast-page-content-card'>
                        {weatherData.map((data) => {
                            return (
                                <div className='forecast-page-content-card-row'>
                                    <div className='forecast-page-content-card-row-top'>
                                        <div className='forecast-page-content-card-row-top-date'>{formatDate(data.dt)}</div> 
                                        <div className='forecast-page-content-card-row-top-figure'>
                                            <img src={rainDropsIcon} className='forecast-page-content-card-row-top-figure-img'/>
                                            {data.rain ? 
                                            <div className='forecast-page-content-card-row-top-figure-text'>{data.rain.toFixed(2)} mm</div> 
                                            : 
                                            <div className='forecast-page-content-card-row-top-figure-no-text'>N/A</div>}
                                        </div>
                                        <div className='forecast-page-content-card-row-top-figure'>
                                            <img src={tempBlueIcon} className='forecast-page-content-card-row-top-figure-img'/>
                                            {data.temp && data.temp.min ? 
                                            <div className='forecast-page-content-card-row-top-figure-text'>{((data.temp.min - 273.15) * (9/5) + 32).toFixed(0)}°F (Min)</div> 
                                            : 
                                            <div className='forecast-page-content-card-row-top-figure-no-text'>N/A</div>}
                                        </div>
                                        <div className='forecast-page-content-card-row-top-figure'>
                                            <img src={tempRedIcon} className='forecast-page-content-card-row-top-figure-img'/>
                                            {data.temp && data.temp.max ? 
                                            <div className='forecast-page-content-card-row-top-figure-text'>{((data.temp.max - 273.15) * (9/5) + 32).toFixed(0)}°F (Max)</div> 
                                            : 
                                            <div className='forecast-page-content-card-row-top-figure-no-text'>N/A</div>}
                                        </div>
                                        <div className='forecast-page-content-card-row-top-figure'>
                                            <img 
                                                src={directionArrow} 
                                                className='forecast-page-content-card-row-top-figure-img' 
                                                style={{
                                                    filter: 'invert(50%)',
                                                    transform: `rotate(${calculateArrowRotation(data.deg)}deg)`,
                                                    transition: 'transform 0.3s ease'
                                                }}
                                                />
                                            {data.deg ? 
                                            <div className='forecast-page-content-card-row-top-figure-text'>{getWindDirection(data.deg)}</div> 
                                            : 
                                            <div className='forecast-page-content-card-row-top-figure-no-text'>N/A</div>}
                                        </div>
                                        <div className='forecast-page-content-card-row-top-figure'>
                                            <img style={{ filter: 'invert(50%)' }} src={windIcon} className='forecast-page-content-card-row-top-figure-img'/>
                                            {data.speed ? 
                                            <div className='forecast-page-content-card-row-top-figure-text'>{((data.speed * 2.23694)).toFixed(0)} mph</div>
                                            : 
                                            <div className='forecast-page-content-card-row-top-figure-no-text'>N/A</div>}
                                        </div>
                                        <div className='forecast-page-content-card-row-top-figure'>
                                            <img src={cloudIcon} className='forecast-page-content-card-row-top-figure-img' style={{filter: 'invert(20%)'}}/>
                                            {data.clouds ? 
                                            <div className='forecast-page-content-card-row-top-figure-text'>{data.clouds}%</div> 
                                            : 
                                            <div className='forecast-page-content-card-row-top-figure-no-text'>N/A</div>}
                                        </div>
                                        <div className='forecast-page-content-card-row-top-figure'>
                                            <img style={{ filter: 'invert(50%)' }} src={humidityIcon} className='forecast-page-content-card-row-top-figure-img'/>
                                            {data.humidity ? 
                                            <div className='forecast-page-content-card-row-top-figure-text'>{data.humidity}% Humidity</div> 
                                            : 
                                            <div className='forecast-page-content-card-row-top-figure-no-text'>N/A</div>}
                                        </div>
                                        <div className='forecast-page-content-card-row-top-figure'>
                                            <img style={{ filter: 'invert(50%)' }} src={snowIcon} className='forecast-page-content-card-row-top-figure-img'/>
                                            {data.snow ? 
                                            <div className='forecast-page-content-card-row-top-figure-text'>{data.snow.toFixed(2)} mm</div> 
                                            : 
                                            <div className='forecast-page-content-card-row-top-figure-no-text'>N/A</div>}
                                        </div>
                                    </div>
                                </div>  
                            )
                        })}
                    </div>
                )
            case 'Graph Analytics':
                return (
                    <div className='forecast-page-content-charts'>
                        {graphData ? graphData.map((graph) => {
                            return (
                                <AgCharts 
                                    options={{
                                        title: {
                                            text: graph.title,
                                            fontStyle: "oblique",
                                            
                                            fontSize: 16,
                                            fontFamily: "Arial, sans-serif",
                                            color: "black"
                                        },
                                        subtitle: {
                                            text: "Location: Current Monitoring Area",
                                            fontStyle: "normal",
                                            
                                            fontSize: 13,
                                            fontFamily: "Arial, sans-serif",
                                            color: "black"
                                        },
                                        axes: [
                                            {
                                            type: 'category',
                                            position: 'bottom',
                                            label: {
                                                color: 'black'
                                            }
                                            },
                                            {
                                            type: 'number',
                                            position: 'left',
                                            title: {
                                                text: '',
                                                color: 'black'
                                            },
                                            label: {
                                                color: 'black'
                                            }
                                            }
                                        ],
                                        legend: {
                                            item: {
                                            label: {
                                                color: 'black'
                                            }
                                            }
                                        },
                                        data: graph.data,
                                        series: graph.series,
                                        background: {
                                            fill: "rgba(168, 168, 168, 0)",
                                        },
                                    }}
                                    className="forecast-page-content-chart" 
                                />
                            )
                        })
                        :
                        <div className='map-controls-settings-window-account-section-content-error-text'>Unable to generate graphs. Please try again.</div>
                        }
                    </div>
                )
        }
    }
    return (
        loading ?
        <>
            <br></br>
            <Spinner />
        </>
        :
        weatherData ?
        <div className='forecast-page-content'>
            <div className='forecast-page-content-back-btn' 
                onClick={() => {
                    setMainStage('menu');
                }}
            >
                <img 
                    src={left} 
                    className="forecast-page-content-back-btn-icon"
                />
                Back
            </div>
            <div className='forecast-page-content-tabs'>
                {['7-Day Forecast', 'Graph Analytics'].map((t, index) => (
                    <div
                        key={index}
                        className='forecast-page-content-tabs-tab'
                        style={{
                            borderBottom: t === stage ? '2px solid #0080ff' : ''
                        }}
                        onClick={() => setStage(t)}
                    >
                        {t}
                    </div>
                ))}
            </div>
            {stageSwitch(stage)}
        </div>
        :
        <div style={{ fontSize: '0.9rem', fontWeight: 'bold', color: 'white', paddingTop: '0.5rem' }}>Trouble fetching forecast data. Please try again.</div>
    )
}